import { UrlApi } from "../../services/apirest";

export const fetchFunction = async (dni, patenteCamion, patenteTanque) => {
  const params = new URLSearchParams({
    dni,
    patenteCamion,
    patenteTanque,
  });

  //  //  Debug para verificar lo que se está mandando
  // console.log("📡 Enviando parámetros a verificarAcceso:", {
  //   dni,
  //   patenteCamion,
  //   patenteTanque,
  //   fullUrl: `${UrlApi}/verificarAcceso?${params.toString()}`
  // });


  //urlApi = http://localhost:27020/api
  const response = await fetch(`${UrlApi}/verificarAcceso?${params}`);

  if (!response.ok) {
    let errorMsg = "Error desconocido";
    try {
      const errorData = await response.json();
      errorMsg = errorData.message || errorMsg;
    } catch {
      errorMsg = response.statusText || errorMsg;
    }
    throw new Error(errorMsg);
  }

  const data = await response.json();

  //  // 👇 Debug de la respuesta
  // console.log("✅ Respuesta de verificarAcceso:", data);

  return data;
};
